import React from "react";

const ITEMS = [
  "$1 JELL-O SHOTS",
  "CHEAP & STRONG",
  "POOL · DARTS · FOOSBALL",
  "NO PRETENSE",
  "KARAOKE ALL NIGHT",
  "BYOF — BRING YOUR OWN FOOD",
  "DOWNTOWN HOUSTON",
  "TRUE DIVE",
];

// Two passes for the seamless infinite scroll — stable namespaced keys
const TRACK = [
  ...ITEMS.map((t) => ({ key: `a-${t}`, text: t })),
  ...ITEMS.map((t) => ({ key: `b-${t}`, text: t })),
];

const MarqueeItem = ({ text }) => (
  <div className="flex items-center gap-8 px-8 font-display text-3xl md:text-4xl whitespace-nowrap">
    <span>{text}</span>
    <span className="text-black">✶</span>
  </div>
);

const Marquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-[#FF2A2A] text-white border-y-2 border-black overflow-hidden"
    >
      <div className="marquee-track py-4">
        {TRACK.map((t) => (
          <MarqueeItem key={t.key} text={t.text} />
        ))}
      </div>
    </section>
  );
};

export default Marquee;
